export default __webpack_public_path__ + "static/media/postcard_rich.f03d1e52.jpg";